
<template>
  <div>
    <default-card>
      <template slot="title-left">
        Informações
      </template>
      <template slot="title-right">
        <v-btn v-if="is_component_used_on_settings && is_editable == false" small text class="btn-primary" @click="is_editable = true">Editar</v-btn>
      </template>
      <template slot="content">
        <v-form v-if="!loading" ref="create_company_form" :readonly="!is_editable && is_component_used_on_settings">
          <show-logo :can_edit="is_editable"></show-logo>
          <v-text-field v-model="name" prepend-icon="mdi-information" label="Nome" :rules="required"></v-text-field>
          
          <calendar-date-picker 
            :active_picker="'YEAR'" 
            :required_date='false'
            :max="$dayjs().format('YYYY-MM-DD')" label="Data de nascimento" 
            :is_readonly="!is_editable"
            @datePicked="handleDatePicked" 
            :date="birthdate"
            is_component_show_event
          />     
          
          <v-autocomplete
            v-model="state"
            :items="uf"
            label="Estado"
            prepend-icon="mdi-map-marker" 
            @change="getDistricts(state)"
          />          
          <v-autocomplete
            v-model="city"
            :items="districts"
            label="Cidade"
            prepend-icon="mdi-map-marker"
          />
          <v-textarea rows="2"  v-model="biography" prepend-icon="mdi-information" label="Biografia" ></v-textarea>    
          <div class="mt-3 title primary--text">
            Contatos
          </div>
          <v-text-field v-model="email" prepend-icon="mdi-email" label="Email Principal" :rules="emailRules"></v-text-field>
          <v-text-field v-model="main_phone" prepend-icon="mdi-phone" label="Telefone Principal" v-mask="phoneMask" :rules="required_phone"></v-text-field>
          <template v-if="false">
            <div class="mt-3 title primary--text">
              Endereço
            </div>
            <v-row class="px-3">
              <v-col cols='12' sm='4' class="py-2">
                <v-text-field v-model="address.zip" v-mask="zipMask" @input="fetchZip(address.zip)" label="Cep" :rules="required_zip" prepend-icon="mdi-map-marker"></v-text-field>
              </v-col>
              <v-col cols='12' sm='5' class="py-2">
                <v-text-field v-model="address.street" label="Rua" :rules="required" prepend-icon="mdi-routes"></v-text-field>
              </v-col>
              <v-col cols='12' sm='3' class="py-2">
                <v-text-field v-model="address.number" prefix="nº" label="Numero" type="number" :rules="required" prepend-icon="mdi-number"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="px-3">
              <v-col cols='12' sm='4' class="py-0">
                <v-text-field v-model="address.district" label="Bairro" :rules="required" prepend-icon="mdi-map-marker"></v-text-field>
              </v-col>
              <v-col cols='12' sm='4' class="py-0">
                <v-text-field v-model="address.city" label="Cidade" :rules="required" prepend-icon="mdi-map"></v-text-field>
              </v-col>
              <v-col cols='12' sm='4' class="py-0">
                <v-text-field v-model="address.state" label="Estado" :rules="required" prepend-icon="mdi-map-outline"></v-text-field>
              </v-col>
            </v-row>
          </template>
          <template v-if="false">
            <div class="mt-3 title primary--text">
              Plano
            </div>
          </template>
        </v-form>
      </template>
      <template slot="actions">
        <v-btn v-if="!is_component_used_on_settings || is_editable" small text class="btn-error" @click="is_component_used_on_settings ? $emit('refreshCompany') && setProfileInfo() : $router.go(-1)">Cancelar</v-btn>
        <v-btn v-if="!is_component_used_on_settings || is_editable" small text class="btn-success" @click="submitUser">Salvar</v-btn>
      </template>
    </default-card>
  </div>
</template>

<script>
import validations from "@/mixins/validations";
import cep from 'cep-promise';
import { mapActions, mapState, mapGetters } from 'vuex'
import Api from '@/api'
import ShowLogo from '../shared/ShowLogo.vue';
import CalendarDatePicker from '../events_agenda/calendar/CalendarDatePicker.vue';

export default {
  components: { ShowLogo, CalendarDatePicker},
  name: 'UserData',
  props: {
    is_component_used_on_settings: {
      type: Boolean,
      default: true
    },
    ddd: {
      type: Object,
      default: ()=> {}
    }
  },
  mixins: [ validations ],
  data() {
    return {
      is_editable: false,
      loading: false,
      key: null,
      cpfMask: '###.###.###-##',
      cnpjMask: '##.###.###/####-##',
      zipMask: '##.###-###',
      phoneMask: '(##) # ####-####',
      loading_zip: false,
      plan_id: 1,                                                    
      owner_id: null,                      
      name: "",                 
      document: "",                  
      document_kind: "cpf",                  
      corporate_name: "",    
      email: '',
      main_phone: '',
      birthdate: '',
      state: '',
      city: '',
      biography: '',
      uf: [],
      districts: [],
      address: {
        zip: '',
        number: '',
        street: '',
        city: '',
        state: '',
        district: '',
        full_address: '',
      },
      kind: null,
      logo: null,
      file_local_url: null,
    }
  },
  methods: {
    fetchZip(zip) {
      if(!this.loading_zip && (/^[0-9]{8}$/.test(zip.replace(/[.-]/g,'')))) {
        this.loading_zip = true
        cep(zip.replace(/[.-]/g,'')).then(endereco => {
          const { street, neighborhood, city, state, cep } = endereco 
          this.address = {
            ...this.address,
            street, city, state,
            district: neighborhood, 
          }
        }).finally(()=>{
          this.loading_zip = false
        })
      }
    },
    handleChangeImage(){
      let url = window.URL.createObjectURL(this.logo);
      this.file_local_url = url
    },
    handleDatePicked(date){
      this.birthdate = this.$dayjs(date).format('YYYY/MM/DD')
    },
    clearImage() {
      this.logo = null
      this.file_local_url = null
    },
    prepareEvent(){
      let { name, document, document_kind, corporate_name, email, main_phone, birthdate, address, } = this

      let comp = {
        plan_id: 1,
        owner_id: this.profile.id,
        name,
        document,
        document_kind,
        corporate_name,
        email,
        main_phone,
        birthdate,
        address,
      }
      return comp
    },
    genFormData(){
      let { name, document, document_kind, corporate_name, email, main_phone, address, } = this
      var formData = new FormData();
      if (this.logo) {
        let logo = this.logo;
        formData.append("company[logo]", this.logo);
      };
      formData.append("company[plan_id]", 1);
      formData.append("company[owner_id]", this.profile.id);
      formData.append("company[name]", name);
      formData.append("company[document]", document);
      formData.append("company[document_kind]", document_kind);
      formData.append("company[corporate_name]", corporate_name );
      formData.append("company[email]", email );
      formData.append("company[main_phone]", main_phone);
      formData.append("company[address][zip]", address.zip);
      formData.append("company[address][number]", address.number);
      formData.append("company[address][street]", address.street);
      formData.append("company[address][city]", address.city);
      formData.append("company[address][state]", address.state);
      formData.append("company[address][district]", address.district);
      return formData
    },
    prepareUserToUpdate(){
      let { name, email, main_phone, address, birthdate, city, state, biography } = this
      let user_update = { 
        id: this.profile.id, 
        name, email, main_phone, birthdate, city, state, biography, address: address 
      }
      return user_update
    },
    submitUser() {
      if (this.$refs.create_company_form.validate()) {
        this.saving = true
        // let deb = this.genCompanyWithFormatCurrencyValues()
        let noti = {
          type: 'success',
          msg: 'Feito com sucesso'
        }
        let user_update = this.prepareUserToUpdate()
        Api.User.update(user_update).then(r => r.data).then(company => {
          this.addNotification(noti)
          setTimeout(() => {
            this.$router.go()
          }, 1200);
        }).catch((err) => {
          noti = {
            type: 'error',
            msg: `Erro: ${err}`
          }
          console.log({err});
          this.addNotification(noti)
        }).finally(()=> {
          this.saving = false
        })
        this.is_editable = false
      }
    },
    setProfileInfo(){
      this.is_editable = false
      this.plan_id = this.profile.plan_id                                                    
      this.owner_id = this.profile.owner_id                     
      this.name = this.profile.name              
      this.document = this.profile.document               
      this.document_kind = this.profile.document_kind                  
      this.corporate_name = this.profile.corporate_name 
      this.email = this.profile.email    
      this.main_phone = this.profile.main_phone    
      this.birthdate = this.profile.birthdate   
      this.city = this.profile.city
      this.districts = [{text:this.profile.city}]
      this.state = this.profile.state
      this.uf = [{text:this.profile.state}]
      this.biography = this.profile.biography
      this.kind =  this.profile.kind
      // this.address = {...this.profile.json_attributes.address}
    },
    loadComponent(){
      this.loading = true
      setTimeout(() => {
        this.loading = false
      }, 200);
    },
    getStates(){
      const url = `https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome`;
      fetch(url)
      .then(r => r.json())
      .then(d => {
        d.forEach(function(obj) {
          obj.text = obj.sigla + ' - ' + obj.nome;
          obj.value = obj.sigla;
          
          delete obj.nome;
          
        });
        this.uf = d;
      });
    },
    getDistricts(state){
      this.districts = []
      const url = `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${state}/distritos?orderBy=nome`;
      fetch(url)
      .then(r => r.json())
      .then(d => {
        d.forEach(function(obj) {
          obj.text = obj.nome;
          obj.value = obj.sigla;
          delete obj.nome;
          delete obj.sigla;
        });
        this.districts = d;
      });
    },
    ...mapActions({
      setActiveCompanyId: 'App/setActiveCompanyId',
      addNotification: 'Notification/add',
    })
  },
  mounted() {
    this.loadComponent()
    if(this.is_component_used_on_settings && this.profile){
      this.setProfileInfo()
    }
  },
  computed: {
    profile_avatar(){
      let img = null;
      if (this.file_local_url) {
        img = this.file_local_url
      } else if (this.profile && this.profile.avatar_url){
        img = this.profile.avatar_url
      }

      return img;
    },
    file_kind(){
      return this.logo && this.logo.type
    },
    image_to_show() {
      let img = null;
      if (this.file_local_url) {
        img = this.file_local_url;
      } else {
        // img = this.file_url;
      };

      return img;
    },
    ...mapState({
      profile: state => state.User.user
    })
  },
  watch: {
    
    is_editable (nv){
      if(nv){
        if(this.uf.length > 1){
        }
        this.getStates()
        this.getDistricts(this.state)
      }
    }
  },
}
</script>

<style scoped>

</style>